module.exports = __webpack_public_path__ + "img/Adspect.89456608.png";